import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DailyActivityPanel } from "@/components/DailyActivityPanel";
import { WholeClassQuick } from "@/components/WholeClassQuick";
import { Baby } from "lucide-react";

export function TeacherDailyActivity() {
  const [students, setStudents] = useState([]);
  const [open, setOpen] = useState(null);
  const [groups, setGroups] = useState({});
  useEffect(() => {
    api.get("/my-classes").then(async (r) => {
      const lists = await Promise.all(r.data.map((c) => api.get("/class-students", { params: { class_name: c.class_name, section: c.section } }).then((x) => x.data).catch(() => [])));
      setGroups(Object.fromEntries(r.data.map((c, i) => [`${c.class_name}${c.section && c.section !== "A" ? ` · ${c.section}` : ""}`, lists[i]]).filter(([, l]) => l.length)));
      const seen = new Set();
      setStudents(lists.flat().filter((s) => !seen.has(s.id) && seen.add(s.id)));
    }).catch(() => {});
  }, []);
  return (
    <div data-testid="teacher-daily-activity">
      <h2 className="font-display font-bold text-slate-900 text-lg mb-2 px-1 flex items-center gap-2"><Baby size={18} className="text-pink-600" /> Daily Activity</h2>
      {students.length === 0 ? <p className="text-sm text-slate-500 px-1">No students assigned to you yet.</p> : (
        <div className="flex gap-2 overflow-x-auto pb-1">
          {students.map((s) => (
            <button key={s.id} data-testid={`tda-${s.id}`} onClick={() => setOpen(s)} className="shrink-0 w-24 bg-white rounded-2xl p-2 shadow-sm text-center hover:-translate-y-0.5 transition-transform">
              <div className="h-10 w-10 mx-auto rounded-full bg-pink-50 text-pink-700 flex items-center justify-center font-bold">{s.name.charAt(0)}</div>
              <div className="text-[11px] font-semibold text-slate-800 mt-1 line-clamp-2">{s.name}</div>
            </button>
          ))}
        </div>
      )}
      {Object.keys(groups).length > 0 && <WholeClassQuick groups={groups} />}
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader><DialogTitle className="font-display">Daily Activity · {open?.name}</DialogTitle></DialogHeader>
          {open && <DailyActivityPanel student={open} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
